import { html, SYSConfig } from "../../.."
import { SYSBaseElement } from "../../sysbaseelement"
import type { HeaderMenuDef } from "../headermenu"
import type { SYSTableData, SYSTableDef } from "../table"

export class SYSTableRowHeaderMenuDialog extends SYSBaseElement {
  def: SYSTableDef
  data: SYSTableData
  instance: string
  async init() {
    this.instance = this.dialogInstance
    let tableRowHeaderMenuState = this.state.ovl.libState.tableRowHeaderMenu
    let defId = tableRowHeaderMenuState[`tableDefId${this.instance}`]
    this.data = SYSConfig.app.tableDefIds[defId].getData(this.state)
    this.def = this.data.tableDef[defId]
    await super.init()
  }

  async getUI() {
    return html`
      <ovl-tableheadermenu
        .props=${() => {
          return <HeaderMenuDef>{
            def: { data: this.data, def: this.def },
            instance: this.instance,
          }
        }}
      ></ovl-tableheadermenu>
    `
  }
}
